import { IRoute } from '../IRoute';
import ClubSeasonDates from '../../../scenes/admin/ClubWizard/ClubSeasonDates';
import CreateAccount from '../../../scenes/admin/ClubWizard/CreateAccount';
import CreateClub from '../../../scenes/admin/ClubWizard/CreateClub';
import CreationComplete from '../../../scenes/admin/ClubWizard/CreationComplete';

const ClubWizardRoutes: IRoute[] = [
  {
    actions: ['auth', 'notifications'],
    component: CreateAccount,
    key: '/account',
    path: '/account',
    scope: 'guest'
  },
  {
    actions: ['adminClubs'],
    component: CreateClub,
    key: 'info',
    path: '/info'
  },
  {
    actions: ['adminClubs'],
    component: ClubSeasonDates,
    key: '/:clubId/season',
    path: '/:clubId/season'
  },
  {
    actions: ['adminClubs', 'seasons'],
    component: CreationComplete,
    key: '/:clubId/complete',
    path: '/:clubId/complete'
  }
];

export default ClubWizardRoutes;
